/**
 * Project-specific (PBGAS) ability subjects.
 * These are registered at runtime and augmented at the type level.
 */
export const pbgasAbilitySubjects = [
  'Order',
  'ChangePrice',
  'GoodsReceipt',
] as const;

export type PbgasAbilitySubjectType = (typeof pbgasAbilitySubjects)[number];

export const customSubjectMap = new Map<string, string>([
  ['Order', 'Objednávka'],
  ['ChangePrice', 'Změna ceny'],
  ['GoodsReceipt', 'Príjem tovaru'],
]);

// Module augmentation — makes 'Order' a valid AbilitySubjectType at compile time
declare module '@kinet-open-network/shared/data-access/model' {
  interface AbilitySubjectExtensions {
    pbgas: PbgasAbilitySubjectType;
  }
}
